import "./featured-image.scss";
